import { Row, Col } from "antd";
import DaolInvPage from "./contents/daolInv/consentRMF";
import DaolSecPage from "./contents/daolSec/kyc";
import DaolInvNdidPage from "./contents/daolInv/saNdid";
import DaolSecNdidPage from "./contents/daolSec/saNdid"
import DaolSecClassifyPage from "./contents/daolSec/classify";

import "../assets/styles/admin/home.scss";
import queryString from "query-string";
import { useHistory, useLocation } from "react-router-dom";
import DaolInvReviewSuitAndKycPage from "./contents/daolInv/reviewSuitAndKyc";

const Index = () => {
  const { search } = useLocation();
  const query: any = queryString.parse(search);
  localStorage.setItem("param_from", query?.from);
  localStorage.setItem("param_reques", query?.reques);
  localStorage.setItem("param_customer", query?.customerid);
  const paramFrom = localStorage.getItem("param_from");
  const paramReques = localStorage.getItem("param_reques");
  // const param_customer = localStorage.getItem("param_customer");
  return (
    <div className="home-page">
      <div className="container">
        {/* {console.log("param_from", paramFrom)}
        {console.log("paramReques", paramReques)}
        {console.log("param_customer", param_customer)} */}
        {paramFrom === "daolinv" && paramReques === "consentrmf" ? (
          <>
            <DaolInvPage />
          </>
        ) : paramFrom === "daolinv" && paramReques === "ndid" ? (
          <>
            <DaolInvNdidPage />
          </>
        ) : paramFrom === "daolsec" && paramReques === "ndid" ? (
          <>
            <DaolSecNdidPage />
          </>
        ) : paramFrom === "daolsec" && paramReques === "reviewkyc" ? (
          <>
            <DaolSecPage />
          </>
        ) : paramFrom === "daolinv" && paramReques === "reviewsuitandkyc" ? (
          <>
            <DaolInvReviewSuitAndKycPage />
          </>
        ): paramFrom === "daolsec" && paramReques === "reviewclassify" ? (
          <>
            <DaolSecClassifyPage />
          </>
        ) : (
          <Row className="container-main">
            <Col span={10} className="content-left">
              Test
            </Col>
            <Col span={14} className="content-right"></Col>
          </Row>
        )}
      </div>
    </div>
  );
};
export default Index;
